<template>
    <div id="ClaimCollectionView">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Claim Collection</div>
                    <div class="web-action-btn">
                        <div class="btn-groups text-right">
                            <!-- <router-link class="btn btn-secondary" v-bind:to="{name: 'WarrantyClaimList'}" > <i class="fp-back"> </i> Edit</router-link> -->
                            <button v-if="claim_status != 'posted' && claim_status != 'complete'" title="Edit Collection" class="btn btn-primary"  v-on:click="editCollection()">
                                <i class="fp-edit-icon"> </i> Edit
                            </button>
                            <button v-if="claim_status != 'posted' && claim_status != 'complete'" title="Remove Collection" class="btn btn-danger"  v-on:click="removeCollection()">
                                <i class="fp-delete"> </i> Delete
                            </button>
                            <a href="javascript:void(0)" v-if="claim_status != 'posted' && claim_status != 'complete'" class="btn btn-danger" v-on:click.prevent="closeCollection()" > <i class="fp-process"> </i> Close</a>
                            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click.prevent="BackWarrantyList" > <i class="fp-back"> </i> Back</a>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content claim-collection">
                      <section class="internal-container">
                        <div id="tabs" class="containerTab mt-3">
                          <div class="tabs">
                            <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Claim Collection Details</a>
                            <a v-on:click="activityLogs()" v-bind:class="[ activetab === 2 ? 'active' : '' ]">Activity Log</a>
                          </div>
                          <div class="content">
                            <div v-show="activetab === 1" class="tabcontent">
                        <!-- <section class="internal-container border-top-table-fl"> -->
                            <div class="form-row section-divider">
                                <div class="col-md-6">
                                    <div class="row form-group">
                                        <label class="col">Warranty Claim #:</label>
                                        <span class="col"> {{ claim_number }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Collection #:</label>
                                        <span class="col"> {{ collection_number }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Claim Date:</label>
                                        <span class="col"> {{ claim_date }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Work Order Item:</label>
                                        <span class="col"> {{ wo_item }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Date Collected:</label>
                                        <span class="col"> {{ collection_date }} </span>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="row form-group">
                                        <label class="col">Claim Type:</label>
                                        <span class="col"> {{ titleCase(claim_type) }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Vendor Claim:</label>
                                        <span class="col"> {{ vendor_claim_number }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Vendor:</label>
                                        <span class="col"> {{ vendor }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Disposition:</label>
                                        <span class="col"> {{ titleCase(disposition) }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Credit Memo #:</label>
                                        <span class="col"> {{ credit_memo }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Unit No:</label>
                                        <span class="col"> {{ unit_no }} </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 pull-right">
                                <table aria-describedby="table" class="table table-sm table-bordered" style="font-size:14px;">
                                    <tbody>
                                        <tr>
                                            <td class="bg-gray valign-middle"> Original Cost Claimed: </td>
                                            <td class="text-right"> <span v-if="cost_claimed != ''">${{cost_claimed}} </span></td>
                                        </tr>
                                        <tr>
                                            <td class="bg-gray"> Collection To Date: </td>
                                            <td class="text-right"><span v-if="collection_amount_till_date != '' && collection_amount_till_date != undefined"> ${{collection_amount_till_date}} </span></td>
                                        </tr>
                                        <tr>
                                            <td class="bg-gray"> Adjustment To Date: </td>
                                            <td class="text-right font-semibold"> <span v-if="adjustment_amount_till_date != '' && adjustment_amount_till_date != undefined">${{adjustment_amount_till_date}}</span> </td>
                                        </tr>
                                        <tr>
                                            <td class="bg-gray"> Outstanding Balance: </td>
                                            <td class="text-right font-semibold"> <span v-if="outstanding_balance != ''">${{outstanding_balance}} </span> <span v-else> $0.00 </span></td>
                                        </tr>
                                </tbody>
                                </table>
                            </div>
                            <div class="clearfix"></div>
                        <!-- </section> -->
                            </div>
                            <div v-show="activetab === 2" class="tabcontent" id="customer-activity-logs" >
                                <claim-activity-log-list :activityLogVal="activityLogsTabValue"></claim-activity-log-list>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";
import ActivityLogListView from '@/components/ActivityLogList.vue';
Vue.component("claim-activity-log-list", ActivityLogListView);
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "ClaimCollectionList",
        metaInfo() {
            return {title: "Claim Collection View| " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            term_value: false,
            loading:false,
            canUpdateProgram:false,
            canAddProgram:false,
            claim_number: "",
            description: "",
            warranty: null,
            wo_item_id:null,
            effective_date: "",
            period: "",
            periodTypeArr:[{value:"month",text:"Month"},{value:"year",text:"Year"}],
            periodType:{value:"month",text:"Month"},
            miles:"",
            options: {
                format: 'YYYY-MM-DD',
                useCurrent: false,
            },
            vendor:'',
            vendor_claim_number:'',
            disposition:'',
            cost_claimed:0,
            claim_date:'',
            optionsDate: {
                format: 'MM/DD/YYYY',
                useCurrent: false,
            },
            wo_item:'',
            claim_type:'',
            collection_amount:'',
            adjustment_amount:'',
            outstanding_balance:'',
            claim_number_error_msg:'',
            itemId:'',
            collection_amount_error_msg:'',
            collection_date:'',
            collection_date_error_msg:'',
            credit_memo:'',
            flag:'',
            remaining_amount:'',
            collection_amount_till_date:'',
            adjustment_amount_till_date:'',
            collection_number:'',
            old_collection_amount:'',
            old_adjustment_amount:'',
            claim_status:'',
            woStatus:'',
            unit_no:'',
            activetab: 1,
            activityLogsTabValue: "dontLoadList",
            activityLoaded:false,
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'add_claim_collection') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();

            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3]){
              self.loadCollectionData(segments[3]);
            }

        },
        methods: {
            BackWarrantyList:function(){
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                if (self.$route.query.claim != undefined && self.$route.query.claim > 0){
                    self.$router.push("/list/claim-collection");
                }else
                if (segments[3]){
                    self.$router.push("/warranty-claim/list");

                }
            },
            editCollection:function(){
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");

                if (segments[3]){
                    self.$router.push("/claim-collection/edit/"+segments[3]+'?from=view');
                }
            },

            closeCollection:function(){
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");


                if (self.woStatus == 'closed' || self.woStatus == 'approved'){

                    if (confirm('Are you sure that you want to close this Collection?')) {
                        self.$parent.loading = true;
                        $.ajax({
                            url: process.env.ROOT_API + "/claim-collection/close/"+segments[3],
                            type: "POST",
                            headers: this.ajxHeaders,
                            crossDomain: true,
                            dataType: "json",
                            success: function (data) {
                                self.$parent.loading = false;
                                // self.wo_item = data.content;
                                self.$router.push("/warranty-claim/list");
                                // self.loadCollectionData(segments[3]);

                            },
                            error: function (jqXHR, exception) {
                                self.$parent.loading = false;
                                self.Registerbtn = "Register";
                                self.generateStatusCodeMessage(jqXHR,true,'asset-group-warranties-search')
                            }
                        });
                    }
                }else{
                    self.$swal('','Collection Have Open Work Order','info');
                    return;
                }

            },
            removeCollection:function(){
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");

                if (confirm('Are you sure that you want to remove this Collection?')) {
                    self.$parent.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/claim-collection/remove/"+segments[3],
                        type: "POST",
                        headers: this.ajxHeaders,
                        crossDomain: true,
                        dataType: "json",
                        success: function (data) {
                            self.$parent.loading = false;
                            // self.wo_item = data.content;
                            // self.loadCollectionData(segments[3]);
                            self.$router.push("/warranty-claim/list");

                        },
                        error: function (jqXHR, exception) {
                            self.$parent.loading = false;
                            self.Registerbtn = "Register";
                            self.generateStatusCodeMessage(jqXHR,true,'asset-group-warranties-search')
                        }
                    });
                }
            },
            loadCollectionData:function(collectionId){
                var self = this;

                self.$parent.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/claim-collection/fetch/"+collectionId,
                    type: "GET",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    dataType: "json",
                    success: function (data) {
                        self.$parent.loading = false;
                        // self.wo_item = data.content;
                        self.wo_item = data.content.work_order_no+' | '+data.content.code+' | '+data.content.task;
                        self.claim_number = data.content.claim_number;
                        self.warranty = data.content.warName+'('+data.content.warCode+')';
                        self.failure_date = data.content.failure_date;
                        self.claim_date = data.content.claim_date;
                        self.claim_type = data.content.claim_type;
                        self.disposition = data.content.disposition;
                        self.cost_claimed = data.content.cost_claimed;
                        self.collection_number = data.content.collection_number;
                        self.outstanding_balance = data.content.outstanding_balance;
                        self.collection_amount = data.content.collection_amount;
                        self.adjustment_amount = data.content.adjustment_amount;
                        self.collection_date = data.content.collection_date;
                        self.credit_memo = data.content.credit_memo;
                        self.collection_amount_till_date = data.content.collection_amount_till_date;
                        self.adjustment_amount_till_date = data.content.adjustment_amount_till_date;
                        self.old_collection_amount = data.content.collection_amount;
                        self.old_adjustment_amount = data.content.adjustment_amount;
                        self.description = data.content.description;
                        self.vendor_claim_number = data.content.vendor_claim_number;
                        self.claim_status = data.content.claim_status;
                        if (data.content.veName != '' && data.content.veName != undefined && data.content.veName != null){
                            self.vendor = data.content.veName;
                        }
                        self.woStatus =  data.content.woStatus;
                        if (data.content.unit_no != undefined && data.content.unit_no != null) {
                            self.unit_no = data.content.unit_no;
                        }else{
                            self.unit_no = "-";
                        }
                        // self.calculateRemain('','load');
                    },
                    error: function (jqXHR, exception) {
                        self.$parent.loading = false;
                        self.Registerbtn = "Register";
                        self.generateStatusCodeMessage(jqXHR,true,'asset-group-warranties-search')
                    }
                });
            },
            activityLogs(){

              var self = this;
              var path = window.location.pathname;
              var segments = path.split("/");

              self.$root.$emit('activity_log_opted','claim',segments[3]);
              self.activityLogsTabValue = "loadList";     // flag value set to loadList so that filters in list work properly.
              self.activetab = 2;
            },
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/ClaimCollectionView.vue